import { render, staticRenderFns } from "./CreateReminder.vue?vue&type=template&id=37a12f4e&"
import script from "./CreateReminder.vue?vue&type=script&lang=js&"
export * from "./CreateReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports